/** Shared row-window math for artist/genre browse grids and the album wall. */

export const BROWSE_GRID_GAP = 16;
export const BROWSE_MIN_COLUMN = 180;
export const ALBUM_GRID_MIN_COLUMN = 240;
export const BROWSE_DEFAULT_ROW_HEIGHT = 280;
export const ALBUM_GRID_DEFAULT_ROW_HEIGHT = 348;
export const BROWSE_OVERSCAN_ROWS_TOP = 2;
export const BROWSE_OVERSCAN_ROWS_BOTTOM = 4;
export const BROWSE_INITIAL_VISIBLE_ROWS = 3;

export function getBrowseScrollParent(element) {
  if (!element) return null;
  let node = element.parentElement;
  while (node) {
    const { overflowY } = window.getComputedStyle(node);
    if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') {
      return node;
    }
    node = node.parentElement;
  }
  return null;
}

export function measureBrowseColumnCount(containerWidth, minColumn = BROWSE_MIN_COLUMN) {
  return Math.max(1, Math.floor((containerWidth + BROWSE_GRID_GAP) / (minColumn + BROWSE_GRID_GAP)));
}

/**
 * Pure window range for virtualized browse grids — used in tests and VirtualizedBrowseGrid.
 */
export function computeBrowseWindowRange({
  itemCount,
  columns,
  rowHeight,
  scrollTop,
  viewportHeight,
  overscanTop = BROWSE_OVERSCAN_ROWS_TOP,
  overscanBottom = BROWSE_OVERSCAN_ROWS_BOTTOM,
  initialVisibleRows = BROWSE_INITIAL_VISIBLE_ROWS,
}) {
  const cols = Math.max(1, columns || 1);
  const totalRows = Math.max(1, Math.ceil(itemCount / cols));
  const rh = Math.max(50, rowHeight || BROWSE_DEFAULT_ROW_HEIGHT);
  const vh = Math.max(0, viewportHeight || 0);

  let startRow = 0;
  let endRow = Math.min(totalRows, initialVisibleRows + overscanBottom);

  if (vh > 0) {
    startRow = Math.max(0, Math.floor(scrollTop / rh) - overscanTop);
    const visibleRows = Math.ceil(vh / rh) + overscanTop + overscanBottom;
    endRow = Math.min(totalRows, startRow + visibleRows);
  }

  const startIndex = startRow * cols;
  const endIndex = Math.min(itemCount, endRow * cols);
  const topSpacer = startRow * rh;
  const bottomSpacer = Math.max(0, (totalRows - endRow) * rh);

  return {
    startIndex,
    endIndex,
    topSpacer,
    bottomSpacer,
    startRow,
    endRow,
    mountedCount: endIndex - startIndex,
  };
}
export function isRetainedHiddenViewport(viewportHeight, hasMeasuredBefore) { return viewportHeight <= 0 && hasMeasuredBefore; }
/** Expected mounted album tiles at scroll top — used in virtualization tests. */
export function expectedMountedAlbumGridCards(itemCount, {
  viewportHeight = 900,
  containerWidth = 1200,
  minColumn = ALBUM_GRID_MIN_COLUMN,
  rowHeight = ALBUM_GRID_DEFAULT_ROW_HEIGHT,
} = {}) {
  const columns = measureBrowseColumnCount(containerWidth, minColumn);
  return computeBrowseWindowRange({
    itemCount,
    columns,
    rowHeight,
    scrollTop: 0,
    viewportHeight,
  }).mountedCount;
}
